<template>
  <v-dialog
    max-width="1000"
    persistent
    transition="dialog-bottom-transition"
    v-model="showDialog"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Update Properties</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form">
        <v-card flat v-bind:loading="loading">
          <v-card-title>
            Set Properties
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="Name" v-model="name"> </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="description"
                  label="Description"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat>
          <v-card-title>
            Run Options
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="3">
                <v-radio-group v-model="scheduleOrNow" :mandatory="true">
                  <v-radio label="Run now" value="now"></v-radio>
                  <v-radio label="Schedule" value="schedule"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="9">
                <CloudWatchCronExpressionBuilder
                  v-model="scheduleExpression"
                  v-if="schedule"
                  show-next-events="5"
                >
                </CloudWatchCronExpressionBuilder>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-btn @click="runOperation()" :disabled="this.name === ''"
            >Run</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {
  UPDATE_PROPERTIES,
  SCHEDULE_UPDATE_PROPERTIES
} from '@/domain/showcases/constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import CloudWatchCronExpressionBuilder from '@/components/CWCronExpressionBuilder/CloudWatchCronExpressionBuilder'
import { isScheduleOnceType } from '@/domain/showcases/util/schedule'

export default {
  name: 'UpdateProperties',
  components: {
    CloudWatchCronExpressionBuilder
  },
  data: () => ({
    showDialog: true,
    loading: false,
    description: null,
    name: null,
    scheduleOrNow: 'now',
    scheduleExpression: '',
    message: null
  }),
  props: ['showcase'],
  mounted() {
    this.name = this.showcase.name
    this.description = this.showcase.description
  },
  computed: {
    schedule: function() {
      return this.scheduleOrNow === 'schedule'
    }
  },
  methods: {
    runOperation() {
      this.message = 'Starting Operation'

      let operationHandler =
        this.scheduleOrNow === 'now'
          ? this.operationHandler
          : this.scheduleOperationHandler
      this.message = 'Starting Operation'
      operationHandler()
        .then(response => {
          this.loading = false
          this.message = 'Success!'
          this.closeDialog()
        })
        .catch(err => {
          this.loading = false
          this.message = err
        })
    },
    async operationHandler() {
      return this.$apolloProvider.clients[DOMAIN_NAME].mutate({
        mutation: UPDATE_PROPERTIES,
        variables: {
          showcaseId: this.showcase.showcaseId,
          name: this.name,
          description: this.description
        },
        fetchPolicy: 'no-cache'
      })
    },
    async scheduleOperationHandler() {
      return this.$apolloProvider.clients[DOMAIN_NAME].mutate({
        mutation: SCHEDULE_UPDATE_PROPERTIES,
        variables: {
          showcaseId: this.showcase.showcaseId,
          name: this.name,
          description: this.description,
          scheduleExpression: 'cron(' + this.scheduleExpression + ')',
          scheduleType: isScheduleOnceType(this.scheduleExpression)
            ? 'ONCE'
            : 'PERIODIC'
        },
        fetchPolicy: 'no-cache'
      })
    },
    closeDialog() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped></style>
